module.exports = __webpack_public_path__ + "static/media/download-white.1004a573.svg";